import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
	key: 'authData',
});

const authDataState = atom({
	key: 'authData',
	default: {
		token:'',
		permissions:[],
		isExternalLogin :false,
	},
	effects_UNSTABLE: [persistAtom],
});

export default authDataState;
